import { useQuery } from '@apollo/client';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { ReportEntityType } from 'components/ReportsModule/types';
import { baseWhere } from 'graph/apollo-util';
import GET_CLASSROOM_ENGAGEMENT_CURRICULUM_REPORT from 'graph/reports/get-classrooom-engagement-curriculum-report';
import { useState } from 'react';

import { PrmClassroomEngagementCurriculumReportResult } from 'types/schema-generated-types';

const useClassroomEngagement = () => {
  const [{ entityId, entityType }] = useReportQueryParams();
  const [productCurriculumId, setProductCurriculumId] = useState(null);

  const inputMap: any = {
    [ReportEntityType.CLASSROOM]: { classroomId: entityId },
    [ReportEntityType.DISTRICT]: { organizationId: entityId },
    [ReportEntityType.SCHOOL]: { organizationId: entityId, productCurriculumId },
    [ReportEntityType.USER_GROUP]: { organizationId: entityId, productCurriculumId },
    [ReportEntityType.STUDENT]: { classroomId: entityId },
    [ReportEntityType.USER]: { userId: entityId, productCurriculumId: productCurriculumId } //educator
  };
  const classroomEngagementInput = baseWhere(inputMap?.[entityType]);
  const maybeSkip = () => {
    switch (entityType) {
      case ReportEntityType.USER:
      case ReportEntityType.SCHOOL:
      case ReportEntityType.USER_GROUP:
        return !productCurriculumId;
      default:
        return false;
    }
  };
  const { data, loading } = useQuery<{
    prmClassroomEngagementCurriculumReport: PrmClassroomEngagementCurriculumReportResult;
  }>(GET_CLASSROOM_ENGAGEMENT_CURRICULUM_REPORT, {
    ...classroomEngagementInput,
    skip: maybeSkip(),
    fetchPolicy: 'network-only'
  });

  return [
    {
      prmClassroomEngagementCurriculumReport: data?.prmClassroomEngagementCurriculumReport,
      selectedProductCurriculumId: productCurriculumId,
      loading
    },
    {
      setProductCurriculumId
    }
  ];
};

export default useClassroomEngagement;
